// Site Configuration Constants
const DISCOUNT_PERCENTAGE = process.env.REACT_APP_DISCOUNT_PERCENTAGE || 50;

export const siteConfig = {
  siteName: 'Prime Network',
  siteTagline: 'Connecting Technology with Excellence',
  siteDescription: 'Leading IT services company in international offering server hosting services, SMTP server setup, MongoDB hosting services, email server solutions, and managed infrastructure support.',
  affordableServerMessage:
    'We provide affordable server solutions for small websites at minimal cost. Need help choosing? Get expert guidance and access to discounted deals up to 50%.',
  hostingerLink: process.env.REACT_APP_HOSTINGER_LINK || "https://www.hostinger.com/referral?REFERRALCODE=1KMPHITECH33",
  elasticEmailLink: process.env.REACT_APP_ELASTICEMAIL_LINK || "https://elasticemail.com/referral-reward?r=62fea5da-68cf-45ae-9df8-886de9dc46b6&utm_source=affiliate&utm_medium=referral",
  discountPercentage: DISCOUNT_PERCENTAGE,
  // PayPal Payment Links
  paypalCoffeeTip: process.env.REACT_APP_PAYPAL_COFFEE || "https://www.paypal.me/mkinfosoft/19",
  paypalMongoDBSetup: process.env.REACT_APP_PAYPAL_MONGODB || "https://www.paypal.me/mkinfosoft/149",
  paypalSMTPSetup: process.env.REACT_APP_PAYPAL_SMTP || "https://www.paypal.me/mkinfosoft/249",
};

// Navigation Menu Items
export const menuItems = [
  {
    label: 'Home',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Services',
    path: '/services',
  },
  {
    label: 'Server & Email',
    path: '/server-email',
  },
  {
    label: 'MongoDB Setup',
    path: '/mongodb-setup',
  },
  {
    label: 'SMTP Setup',
    path: '/smtp-setup',
  },
  {
    label: 'Contact Us',
    path: '/contact',
  },
];

// Footer Links
export const footerLinks = {
  services: [
    { label: 'All Services', path: '/services' },
    { label: 'Server & Email Services', path: '/server-email' },
    { label: 'MongoDB Setup', path: '/mongodb-setup' },
    { label: 'SMTP Mail Server', path: '/smtp-setup' },
  ],
  quickLinks: [
    { label: 'Home', path: '/' },
    { label: 'About', path: '/about' },
    { label: 'Affordable Server Solutions', path: '/server-email' },
    { label: 'Contact Us', path: '/contact' },
  ],
};
